module.exports = "https://cdn.dashboard.gifty.nl/5780/images/emoti-2.png?8cdabb02edd1722c4b3128c693e113cd";